<div class="app-textarea-input">
  <label *ngIf="label" class="app-textarea-input__label" [attr.for]="id">{{ label }}</label>

  <textarea
    class="form-control app-textarea-input__control"
    [ngClass]="[
      textareaClass,
      showError ? 'error-field' : ''
    ]"
    [attr.id]="id"
    [attr.name]="name || id"
    [attr.placeholder]="placeholder"
    [attr.autocomplete]="autocomplete"
    [attr.rows]="rows"
    [disabled]="disabled"
    [value]="value"
    (input)="inputChanged($event)"
    (blur)="onTouched()"></textarea>

  <span *ngIf="showError && errorMessage" class="error-text">{{ errorMessage }}</span>
</div>
